import Vue from 'vue'
import { CacheService } from '@valo/cache'

Vue.prototype.$cache = new CacheService('WalletCache')
Vue.prototype.$cache.init()
